<template>
  <vSelect
      :id="_uid"
      v-model="internalValue"
      v-bind="$attrs"
      :placeholder="placeholderText"
      :autoscroll="true"
      :label="label"
      :options="options"
      :name="name"
      :ref="_uid"
      :key="name"
      :inputId="name + '.Input'"
      :disabled="disabled"
      :reduce="reduce"
      :filter="filter"
      :clearable="clearable"
      :selectOnTab="true"
      class="vSelect-dynamic-width"
      @close="close"
  />
</template>
<script>
import vSelect from 'vue-select';

export default {
  components: { vSelect },

  inheritAttrs: false,

  props: {
    value: null,
    name: String,
    placeholder: { type: String, required: true },
    label: { type: String, default: 'label' },
    options: { type: Array, required: true },
    disabled: { default: false },
    clearable: { default: true },
    dynamicWidth: { type: Boolean, required: true },
    filter: { type: Function, default: null },
    reduce: {
      type: Function,
      default: (option) => option,
    },
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    placeholderText() {
      if (this.options.length > 0) return this.placeholder;
      return this.$t('core.loading');
    },

    getWidth() {
      if (!this.options.length) return 0;

      const longest = this.options.reduce((a, b) =>
          this.getOptionLabel(a).length > this.getOptionLabel(b).length ? a : b
      );

      return this.getOptionLabel(longest).length * 7.8;
    }
  },

  watch: {
    options() {
      this.setStyle();
    },
    value() {
      this.$refs[this._uid]._data.typeAheadPointer = -1;
    }
  },

  mounted() {
    this.setStyle();
  },

  methods: {
    close() {
      const index = this.options.findIndex(
          el => this.reduce(el) === this.value
      );
      this.$refs[this._uid].$data.typeAheadPointer = index;
    },

    getOptionLabel(option) {
      return typeof option === 'object' ? option[this.label] : option;
    },

    setStyle() {
      if (!this.dynamicWidth) return;

      const element = document.getElementById(this._uid);
      const ul = element.getElementsByTagName('ul');

      const minWidth = this.$refs[this._uid].$el.clientWidth;
      const width = this.getWidth;

      ul[0].style.minWidth = minWidth + 'px';
      ul[0].style.width = width > minWidth ? width + 'px' : minWidth + 'px';
    }
  }
};
</script>

<style>
.vs__selected-options {
  width: 129px;
  overflow: hidden;
  white-space: nowrap;
  flex-wrap: nowrap !important;
}
.v-select ul {
  min-width: max-content !important; /*or some other pixel value < 160*/
}
</style>
